import styles from "./ErrorScreen.module.css";

export interface ErrorScreenProps {
  error: Error;
  title?: string;
  fallbackMessage?: string;
  reloadLabel?: string;
}

export function ErrorScreen({
  error,
  title = "Noe gikk galt",
  fallbackMessage = "Ukjent feil",
  reloadLabel = "Last på nytt",
}: ErrorScreenProps) {
  return (
    <div data-testid="error-screen" className={styles.screen}>
      <div className={styles.card}>
        <div className={styles.title}>{title}</div>
        <div className={styles.message} data-testid="error-message">
          {error.message || fallbackMessage}
        </div>
        {error.stack && <pre className={styles.stack}>{error.stack}</pre>}
        <button
          type="button"
          data-testid="error-reload-button"
          onClick={() => window.location.reload()}
          className={styles.reloadButton}
        >
          {reloadLabel}
        </button>
      </div>
    </div>
  );
}
